<template>
	<div class="brand-card sk-widget" @click="goToMenu">
		<div class="brand-image" :style="brandImageStyle" />
		<div class="title text-truncate">{{ brand.name }}</div>
	</div>
</template>

<style scoped>
.brand-card {
	padding: 10px;
	margin-bottom: 0;
	cursor: pointer;
}

.brand-image {
	height: 150px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	border-top-right-radius: 5px;
	border-top-left-radius: 5px;
}

.title {
	color: var(--gR-base-80);
	font-size: 14px;
	font-weight: var(--sk-font-bold);
	padding: 0;
	height: 40px;
	padding-top: 10px;
	display: flex;
	align-items: center;
	margin-left: 5px;
}
</style>

<script>
export default {
	name: "BrandCard",
	props: {
		brand: Object
	},
	computed: {
		brandImageStyle() {
			return {
				backgroundImage: `url(${process.env.VUE_APP_BASE_BRANDS_IMAGE_URL}${this.brand.id}/${this.brand.img})`
			}
		}
	},
	methods: {
		goToMenu() {
			this.$router.push({
				path: `/${this.$route.params.slug}/menu`,
				query: { brandId: this.brand.id }
			})
		}
	}
}
</script>